module.exports = ['$scope', 'ngMeta', 'bibContentManager', 'settings', '$q', '$document', '$window', '$state', '$timeout', '$stateParams',
  function ($scope, ngMeta, bibContentManager, settings, $q, $document, $window, $state, $timeout, $stateParams) {
  'use strict';
  ngMeta.setTitle('Concept: leeruitkomst');

  var viewItem;
  var offset = 105;
  var firstSection;
  var d = $q.defer();

    $scope.$parent.loading = true;
    bibContentManager.getContent(settings.concept.leeruitkomst, ['HORIZONTAL_RULE', 'SECTION', 'MUSIC', 'ATTACHEMENTS_GROUP', 'VIDEO', 'ATTACHMENT', 'PARAGRAPH', 'VIDEO_GROUP', 'ATTACHMENTS_GROUP', 'TERM', 'IMAGE', 'IMAGE_GROUP', 'REFERENCE']).then(function(content){
      firstSection = _.find(content.contents, {type: 'SECTION'});
      if(!$stateParams.key) {
        $scope.viewItem = firstSection;
      } else {
        $scope.viewItem = _.find(content.contents, {key: $stateParams.key});
      }
      viewItem = $scope.viewItem;
      $scope.isFirstSection = firstSection.key === viewItem.key;
      $scope.root = content;
      d.resolve(content);
      $scope.$parent.coverImg = content.cover.url;
      var next = _.find(_.filter($scope.root.contents, {type: 'SECTION'}), {readorder: parseInt(viewItem.readorder, 0) + 1});
      //if (!next) { next = root.contents[0]; }
      $scope.next = next;

      var prev = _.find(_.filter($scope.root.contents, {type: 'SECTION'}), {readorder: parseInt(viewItem.readorder, 0) - 1});
      //if (!prev) { prev = root.contents[root.contents.length - 1]; }
      $scope.prev = prev;
      $scope.$parent.loading = false;

    });

  $scope.loadedPromise = d.promise;

  $scope.find = function (key) {
    function findWithKey(keyToFind, document) {
      var found;
      document.contents.forEach(function (item) {
        if (item.key === keyToFind) {
          found = item;
          return false;
        } else if (item.contents && !found) {
          found = findWithKey(keyToFind, item);
          if (found) {
            return false;
          }
        }
      });
      return found;
    }
    return findWithKey(key, $scope.document);
  };

  $scope.findNext = function (item) {
    var parent = $scope.find(item.parent.key);
  };

  var scollListner = function (e) {
    if(viewItem) {
      var prev;
      _.filter(viewItem.contents, {type: 'SECTION'}).forEach(function (level1Content) {
        level1Content.position = elmYPosition(level1Content.key);
        if (prev) {
          level1Content.prevPosition = prev.position;
          prev.nextPosition = level1Content.position;
        } else {
          level1Content.prevPosition = level1Content.position;
        }
        prev = level1Content;
        prev.nextPosition = elmYPosition('refEnd');
      });

      var position = $window.scrollY;
      var key;
      var current;

      if (viewItem && viewItem.contents) {
        current = _.find(viewItem.contents, function (o) {
          return (o.prevPosition < position + offset) && (o.nextPosition > position + offset) && o.type === 'SECTION';
        });
        if (current) {
          key = current.key;
        } else {
          key = viewItem.key;
        }
        if (key) {
          $scope.selected = key;
          $scope.$apply();
        }
      }
    }
  };

  $document.on('scroll', scollListner);

  $scope.$on('$destroy', function () {
    $document.off('scroll', scollListner);
  });

  function elmYPosition(eID) {
    var elm = document.getElementById(eID);
    if(!elm){
      console.warn(eID + ' is not found');
    } else {
      var y = elm.offsetTop;
      var node = elm;
      while (node.offsetParent && node.offsetParent != document.body) {
        node = node.offsetParent;
        y += node.offsetTop;
      }
      return y;
    }
  }

    $scope.goLevel1 = function (key) {
    window.scrollTo(0, elmYPosition(key) - offset + 1);
  };

  $scope.goLevel2 = function (key) {
    window.scrollTo(0, elmYPosition(key) - offset + 1);
  };

    $scope.footnotes = [];
    var footnotes = [];
    $scope.replaceRef = function (html) {
      html.match(/<a.*href=".*(\/content\/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}).*".*rel="footnote".*>\[(.*)\]<\/a>/g).forEach(function (matchItem) {
        var footnote = (/([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})/).exec(matchItem);
        footnotes.push($scope.$parent.find(footnote[1]));
      });
      footnotes = _.uniq(footnotes);
      $scope.footnotes = footnotes;
      return html.replace(/<a.*href=".*(\/content\/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}).*".*rel="footnote".*>\[(.*)\]<\/a>/g, "<sup>$2</sup>")
    };

  }];


// WEBPACK FOOTER //
// ./web/js/screen/concept/leeruitkomst/conceptLeeruitkomstController.js